import * as $runtime from "../runtime.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUTCTime from "../Data.UTCTime/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCountries from "../Restaumatic.Countries/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dOrders$dCheckout$dTypes from "../Restaumatic.Orders.Checkout.Types/index.js";
import * as Restaumatic$dOrders$dPayments$dDotpay$dTypes from "../Restaumatic.Orders.Payments.Dotpay.Types/index.js";
import * as Restaumatic$dOrders$dPayments$dTypes from "../Restaumatic.Orders.Payments.Types/index.js";
import * as Restaumatic$dOrders$dTypes from "../Restaumatic.Orders.Types/index.js";
import * as Restaumatic$dOrders$dTypes$dFulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic$dOrders$dTypes$dOrderInfo from "../Restaumatic.Orders.Types.OrderInfo/index.js";
import * as Restaumatic$dOrders$dTypes$dPaymentMethod from "../Restaumatic.Orders.Types.PaymentMethod/index.js";
import * as Restaumatic$dPromotions$dLoyalty$dTypes$dUserLoyalty from "../Restaumatic.Promotions.Loyalty.Types.UserLoyalty/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $GetOrderSummaryRequest = _1 => ({tag: "GetOrderSummaryRequest", _1});
const $OrderSummaryState = (tag, _1, _2) => ({tag, _1, _2});
const $PlaceOrderResponse = (tag, _1) => ({tag, _1});
const Errors = value0 => $PlaceOrderResponse("Errors", value0);
const Redirect = value0 => $PlaceOrderResponse("Redirect", value0);
const ExternalRedirect = value0 => $PlaceOrderResponse("ExternalRedirect", value0);
const PaymentForm = value0 => $PlaceOrderResponse("PaymentForm", value0);
const ApplePayResponseToken = value0 => $PlaceOrderResponse("ApplePayResponseToken", value0);
const PlaceOrderRequest = x => x;
const Placed = /* #__PURE__ */ $OrderSummaryState("Placed");
const WaitingForPayment = /* #__PURE__ */ $OrderSummaryState("WaitingForPayment");
const WaitingForDispatch = value0 => $OrderSummaryState("WaitingForDispatch", value0);
const WaitingForConfirmation = /* #__PURE__ */ $OrderSummaryState("WaitingForConfirmation");
const Completed = value0 => value1 => $OrderSummaryState("Completed", value0, value1);
const Cancelled = value0 => $OrderSummaryState("Cancelled", value0);
const GetOrderSummaryResponse = x => x;
const GetOrderSummaryRequest = value0 => $GetOrderSummaryRequest(value0);
const GetCheckoutInfoRequest = x => x;
const FulfillmentTimeChoice = x => x;
const CheckoutInfo = x => x;
const rPCMethodNamePlaceOrderRe = {rpcMethodName: v => "PlaceOrderRequest"};
const rPCMethodNameGetOrderSumm = {rpcMethodName: v => "GetOrderSummaryRequest"};
const rPCMethodNameGetCheckoutI = {rpcMethodName: v => "GetCheckoutInfoRequest"};
const newtypePlaceOrderRequest_ = {Coercible0: () => {}};
const newtypeGetOrderSummaryRes = {Coercible0: () => {}};
const newtypeGetCheckoutInfoReq = {Coercible0: () => {}};
const newtypeFulfillmentTimeCho = {Coercible0: () => {}};
const newtypeCheckoutInfo_ = {Coercible0: () => {}};
const hasFieldPlaceOrderRequest = dictHasField => dictHasField;
const hasFieldGetOrderSummaryRe = dictHasField => dictHasField;
const hasFieldGetCheckoutInfoRe = dictHasField => dictHasField;
const hasFieldFulfillmentTimeCh = dictHasField => dictHasField;
const hasFieldCheckoutInfo = dictHasField => dictHasField;
const eqPlaceOrderResponse = {
  eq: x => y => {
    if (x.tag === "Errors") {
      if (y.tag === "Errors") { return Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x._1)(y._1); }
      return false;
    }
    if (x.tag === "Redirect") {
      if (y.tag === "Redirect") { return x._1.orderUUID === y._1.orderUUID && x._1.url === y._1.url; }
      return false;
    }
    if (x.tag === "ExternalRedirect") {
      if (y.tag === "ExternalRedirect") { return x._1.orderUUID === y._1.orderUUID && x._1.url === y._1.url; }
      return false;
    }
    if (x.tag === "PaymentForm") {
      if (y.tag === "PaymentForm") { return Restaumatic$dOrders$dPayments$dTypes.eqForm.eq(x._1.form)(y._1.form) && x._1.orderUUID === y._1.orderUUID; }
      return false;
    }
    if (x.tag === "ApplePayResponseToken") {
      if (y.tag === "ApplePayResponseToken") { return x._1.orderUUID === y._1.orderUUID && x._1.token === y._1.token && x._1.url === y._1.url; }
      return false;
    }
    return false;
  }
};
const eqPlaceOrderRequest = {
  eq: x => y => Restaumatic$dOrders$dCheckout$dTypes.eqCheckoutRequest.eq(x.checkout)(y.checkout) && x.origin === y.origin && (() => {
    if (x.payment.tag === "Nothing") { return y.payment.tag === "Nothing"; }
    if (x.payment.tag === "Just") {
      if (y.payment.tag === "Just") { return Restaumatic$dOrders$dPayments$dTypes.eqPaymentRequest.eq(x.payment._1)(y.payment._1); }
      return false;
    }
    return false;
  })() && (() => {
    if (x.paymentChannel.tag === "Nothing") { return y.paymentChannel.tag === "Nothing"; }
    if (x.paymentChannel.tag === "Just") {
      if (y.paymentChannel.tag === "Just") { return x.paymentChannel._1 === y.paymentChannel._1; }
      return false;
    }
    return false;
  })()
};
const eqOrderSummaryState = {
  eq: x => y => {
    if (x.tag === "Placed") { return y.tag === "Placed"; }
    if (x.tag === "WaitingForPayment") { return y.tag === "WaitingForPayment"; }
    if (x.tag === "WaitingForDispatch") {
      if (y.tag === "WaitingForDispatch") { return x._1.openAt === y._1.openAt; }
      return false;
    }
    if (x.tag === "WaitingForConfirmation") { return y.tag === "WaitingForConfirmation"; }
    if (x.tag === "Completed") {
      if (y.tag === "Completed") { return x._1 === y._1 && Data$dDateTime.eqDateTime.eq(x._2)(y._2); }
      return false;
    }
    if (x.tag === "Cancelled") {
      if (y.tag === "Cancelled") {
        if (x._1.tag === "Nothing") { return y._1.tag === "Nothing"; }
        if (x._1.tag === "Just") {
          if (y._1.tag === "Just") { return x._1._1 === y._1._1; }
          return false;
        }
        return false;
      }
      return false;
    }
    return false;
  }
};
const eqGetOrderSummaryResponse = {
  eq: x => y => Restaumatic$dOrders$dTypes$dOrderInfo.eqOrderInfo.eq(x.orderInfo)(y.orderInfo) && x.restaurantAddressCity === y.restaurantAddressCity && (() => {
    if (x.restaurantAddressPostCode.tag === "Nothing") { return y.restaurantAddressPostCode.tag === "Nothing"; }
    if (x.restaurantAddressPostCode.tag === "Just") {
      if (y.restaurantAddressPostCode.tag === "Just") { return x.restaurantAddressPostCode._1 === y.restaurantAddressPostCode._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.restaurantAddressStreet.tag === "Nothing") { return y.restaurantAddressStreet.tag === "Nothing"; }
    if (x.restaurantAddressStreet.tag === "Just") {
      if (y.restaurantAddressStreet.tag === "Just") { return x.restaurantAddressStreet._1 === y.restaurantAddressStreet._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.restaurantApetiloImage.tag === "Nothing") { return y.restaurantApetiloImage.tag === "Nothing"; }
    if (x.restaurantApetiloImage.tag === "Just") {
      if (y.restaurantApetiloImage.tag === "Just") { return x.restaurantApetiloImage._1 === y.restaurantApetiloImage._1; }
      return false;
    }
    return false;
  })() && x.restaurantId === y.restaurantId && x.restaurantName === y.restaurantName && (() => {
    if (x.restaurantPhones.tag === "Nothing") { return y.restaurantPhones.tag === "Nothing"; }
    if (x.restaurantPhones.tag === "Just") {
      if (y.restaurantPhones.tag === "Just") { return x.restaurantPhones._1 === y.restaurantPhones._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.restaurantSlug.tag === "Nothing") { return y.restaurantSlug.tag === "Nothing"; }
    if (x.restaurantSlug.tag === "Just") {
      if (y.restaurantSlug.tag === "Just") { return x.restaurantSlug._1 === y.restaurantSlug._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.siteName.tag === "Nothing") { return y.siteName.tag === "Nothing"; }
    if (x.siteName.tag === "Just") {
      if (y.siteName.tag === "Just") { return x.siteName._1 === y.siteName._1; }
      return false;
    }
    return false;
  })() && eqOrderSummaryState.eq(x.state)(y.state) && (() => {
    if (x.userLoyalty.tag === "Nothing") { return y.userLoyalty.tag === "Nothing"; }
    if (x.userLoyalty.tag === "Just") {
      if (y.userLoyalty.tag === "Just") { return Restaumatic$dPromotions$dLoyalty$dTypes$dUserLoyalty.eqUserLoyalty.eq(x.userLoyalty._1)(y.userLoyalty._1); }
      return false;
    }
    return false;
  })()
};
const eqGetOrderSummaryRequest = {eq: x => y => x._1.orderId === y._1.orderId};
const eqGetCheckoutInfoRequest = {
  eq: x => y => x.isQrWaiterOrder === y.isQrWaiterOrder && (() => {
    if (x.locale.tag === "PL") { return y.locale.tag === "PL"; }
    if (x.locale.tag === "EN") { return y.locale.tag === "EN"; }
    if (x.locale.tag === "EN_GB") { return y.locale.tag === "EN_GB"; }
    if (x.locale.tag === "RO") { return y.locale.tag === "RO"; }
    if (x.locale.tag === "RU") { return y.locale.tag === "RU"; }
    if (x.locale.tag === "CS") { return y.locale.tag === "CS"; }
    if (x.locale.tag === "SK") { return y.locale.tag === "SK"; }
    if (x.locale.tag === "HR") { return y.locale.tag === "HR"; }
    if (x.locale.tag === "DE") { return y.locale.tag === "DE"; }
    if (x.locale.tag === "NL") { return y.locale.tag === "NL"; }
    if (x.locale.tag === "ES") { return y.locale.tag === "ES"; }
    if (x.locale.tag === "IT") { return y.locale.tag === "IT"; }
    if (x.locale.tag === "UK") { return y.locale.tag === "UK"; }
    if (x.locale.tag === "PT_BR") { return y.locale.tag === "PT_BR"; }
    return false;
  })() && x.restaurantId === y.restaurantId
};
const eqFulfillmentTimeChoice = {
  eq: x => y => x.label === y.label && (() => {
    if (x.value.tag === "Nothing") { return y.value.tag === "Nothing"; }
    if (x.value.tag === "Just") {
      if (y.value.tag === "Just") { return Data$dDateTime.eqDateTime.eq(x.value._1)(y.value._1); }
      return false;
    }
    return false;
  })()
};
const eqCheckoutInfo = {
  eq: x => y => x.companyCity === y.companyCity && x.companyName === y.companyName && (() => {
    if (x.country.tag === "PL") { return y.country.tag === "PL"; }
    if (x.country.tag === "GB") { return y.country.tag === "GB"; }
    if (x.country.tag === "RU") { return y.country.tag === "RU"; }
    if (x.country.tag === "RO") { return y.country.tag === "RO"; }
    if (x.country.tag === "CZ") { return y.country.tag === "CZ"; }
    if (x.country.tag === "HR") { return y.country.tag === "HR"; }
    if (x.country.tag === "SK") { return y.country.tag === "SK"; }
    if (x.country.tag === "DE") { return y.country.tag === "DE"; }
    if (x.country.tag === "NL") { return y.country.tag === "NL"; }
    if (x.country.tag === "ES") { return y.country.tag === "ES"; }
    if (x.country.tag === "BR") { return y.country.tag === "BR"; }
    if (x.country.tag === "IT") { return y.country.tag === "IT"; }
    return false;
  })() && (() => {
    if (x.franchiseName.tag === "Nothing") { return y.franchiseName.tag === "Nothing"; }
    if (x.franchiseName.tag === "Just") {
      if (y.franchiseName.tag === "Just") { return x.franchiseName._1 === y.franchiseName._1; }
      return false;
    }
    return false;
  })() && Data$dEq.eqArrayImpl(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.eqFulfillmentMethodType.eq)(x.fulfillmentMethods)(y.fulfillmentMethods) && Data$dEq.eqArrayImpl(eqFulfillmentTimeChoice.eq)(x.fulfillmentTimes)(y.fulfillmentTimes) && x.paylanePublicApiKey === y.paylanePublicApiKey && Data$dEq.eqArrayImpl(Restaumatic$dOrders$dTypes$dPaymentMethod.eqPaymentMethod.eq)(x.paymentMethods)(y.paymentMethods) && x.restaurantName === y.restaurantName && x.signedIn === y.signedIn
};
const genericPlaceOrderResponse = {
  to: x => {
    if (x.tag === "Inl") { return $PlaceOrderResponse("Errors", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $PlaceOrderResponse("Redirect", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $PlaceOrderResponse("ExternalRedirect", x._1._1._1); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return $PlaceOrderResponse("PaymentForm", x._1._1._1._1); }
          if (x._1._1._1.tag === "Inr") { return $PlaceOrderResponse("ApplePayResponseToken", x._1._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Errors") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "Redirect") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ExternalRedirect") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "PaymentForm") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))); }
    if (x.tag === "ApplePayResponseToken") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))));
    }
    $runtime.fail();
  }
};
const showPlaceOrderResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
      return {genericShowArgs: v => [$0(v)]};
    })())({reflectSymbol: () => "Errors"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["orderUUID", Restaumatic$dOrders$dTypes.showOrderUUID.show(v.orderUUID)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "url",
            Data$dShow.showStringImpl(v.url)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Redirect"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["orderUUID", Restaumatic$dOrders$dTypes.showOrderUUID.show(v.orderUUID)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "url",
            Data$dShow.showStringImpl(v.url)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ExternalRedirect"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["form", Restaumatic$dOrders$dPayments$dTypes.showForm.show(v.form)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "orderUUID",
            Restaumatic$dOrders$dTypes.showOrderUUID.show(v.orderUUID)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "PaymentForm"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["orderUUID", Restaumatic$dOrders$dTypes.showOrderUUID.show(v.orderUUID)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "token",
            Data$dShow.showStringImpl(v.token)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["url", Data$dShow.showStringImpl(v.url)]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ApplePayResponseToken"});
    return x => {
      const $5 = genericPlaceOrderResponse.from(x);
      if ($5.tag === "Inl") { return $0["genericShow'"]($5._1); }
      if ($5.tag === "Inr") {
        if ($5._1.tag === "Inl") { return $1["genericShow'"]($5._1._1); }
        if ($5._1.tag === "Inr") {
          if ($5._1._1.tag === "Inl") { return $2["genericShow'"]($5._1._1._1); }
          if ($5._1._1.tag === "Inr") {
            if ($5._1._1._1.tag === "Inl") { return $3["genericShow'"]($5._1._1._1._1); }
            if ($5._1._1._1.tag === "Inr") { return $4["genericShow'"]($5._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodePlaceOrderResponse = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "Errors"})((() => {
      const $0 = Unscramble.decodeArray(Unscramble.decodeString);
      return {unsafeDecodeSingleConstructorArgument: x => $0(x.contents)};
    })()))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "Redirect"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "orderUUID"})(Restaumatic$dOrders$dTypes.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "url"
      })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ExternalRedirect"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "orderUUID"})(Restaumatic$dOrders$dTypes.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "url"
      })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "PaymentForm"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "form"})(Restaumatic$dOrders$dPayments$dTypes.unscrambleDecodeForm)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "orderUUID"
      })(Restaumatic$dOrders$dTypes.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ApplePayResponseToken"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "orderUUID"})(Restaumatic$dOrders$dTypes.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "token"
      })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "url"})(Unscramble.decodeString1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
    }))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericPlaceOrderResponse.to($0(x));
  })()
};
const genericPlaceOrderRequest = {to: x => x, from: x => x};
const showPlaceOrderRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["checkout", Restaumatic$dOrders$dCheckout$dTypes.showCheckoutRequest.show(v.checkout)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "origin",
            Data$dShow.showStringImpl(v.origin)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "payment",
            (() => {
              if (v.payment.tag === "Just") { return "(Just " + Restaumatic$dOrders$dPayments$dTypes.showPaymentRequest.show(v.payment._1) + ")"; }
              if (v.payment.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "paymentChannel",
            (() => {
              if (v.paymentChannel.tag === "Just") { return "(Just " + Restaumatic$dOrders$dPayments$dDotpay$dTypes.showChannelId.show(v.paymentChannel._1) + ")"; }
              if (v.paymentChannel.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "PlaceOrderRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodePlaceOrderRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "checkout"})(Restaumatic$dOrders$dCheckout$dTypes.unscrambleDecodeCheckoutRequest)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "origin"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "payment"})(Unscramble.decodeMaybe(Restaumatic$dOrders$dPayments$dTypes.unscrambleDecodePaymentRequest))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "paymentChannel"
    })(Unscramble.decodeMaybe(Restaumatic$dOrders$dPayments$dDotpay$dTypes.unscrambleDecodeChannelId))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericOrderSummaryState = {
  to: x => {
    if (x.tag === "Inl") { return Placed; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return WaitingForPayment; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $OrderSummaryState("WaitingForDispatch", x._1._1._1); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return WaitingForConfirmation; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return $OrderSummaryState("Completed", x._1._1._1._1._1._1, x._1._1._1._1._1._2); }
            if (x._1._1._1._1.tag === "Inr") { return $OrderSummaryState("Cancelled", x._1._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Placed") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "WaitingForPayment") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "WaitingForDispatch") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "WaitingForConfirmation") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "Completed") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2)))))
      );
    }
    if (x.tag === "Cancelled") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)))));
    }
    $runtime.fail();
  }
};
const showOrderSummaryState = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Placed"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "WaitingForPayment"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["openAt", Data$dShow.showStringImpl(v.openAt)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "WaitingForDispatch"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "WaitingForConfirmation"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})({
      genericShowArgs: v => [DateUtils.formatISODateTime(v)]
    }))({reflectSymbol: () => "Completed"});
    const $5 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v._1) + ")"; }
          if (v.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })()
      ]
    })({reflectSymbol: () => "Cancelled"});
    return x => {
      const $6 = genericOrderSummaryState.from(x);
      if ($6.tag === "Inl") { return $0["genericShow'"]($6._1); }
      if ($6.tag === "Inr") {
        if ($6._1.tag === "Inl") { return $1["genericShow'"]($6._1._1); }
        if ($6._1.tag === "Inr") {
          if ($6._1._1.tag === "Inl") { return $2["genericShow'"]($6._1._1._1); }
          if ($6._1._1.tag === "Inr") {
            if ($6._1._1._1.tag === "Inl") { return $3["genericShow'"]($6._1._1._1._1); }
            if ($6._1._1._1.tag === "Inr") {
              if ($6._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($6._1._1._1._1._1); }
              if ($6._1._1._1._1.tag === "Inr") { return $5["genericShow'"]($6._1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeOrderSummaryState = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "Placed"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "WaitingForPayment"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "WaitingForDispatch"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "openAt"})(Unscramble.decodeString1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "WaitingForConfirmation"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
      argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dTime$dLocal.udecodeTZLabel.unsafeDecode(array[offset]))
    })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUTCTime.unscrambleDecodeUTCTime.unsafeDecode(array[offset]))})))({reflectSymbol: () => "Completed"}))(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "Cancelled"
    })((() => {
      const $0 = Unscramble.decodeMaybe(Unscramble.decodeString1);
      return {unsafeDecodeSingleConstructorArgument: x => $0.unsafeDecode(x.contents)};
    })())))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericOrderSummaryState.to($0(x));
  })()
};
const genericGetOrderSummaryResponse = {to: x => x, from: x => x};
const showGetOrderSummaryResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["orderInfo", Restaumatic$dOrders$dTypes$dOrderInfo.showOrderInfo.show(v.orderInfo)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "restaurantAddressCity",
            Data$dShow.showStringImpl(v.restaurantAddressCity)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "restaurantAddressPostCode",
            (() => {
              if (v.restaurantAddressPostCode.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.restaurantAddressPostCode._1) + ")"; }
              if (v.restaurantAddressPostCode.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "restaurantAddressStreet",
            (() => {
              if (v.restaurantAddressStreet.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.restaurantAddressStreet._1) + ")"; }
              if (v.restaurantAddressStreet.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "restaurantApetiloImage",
            (() => {
              if (v.restaurantApetiloImage.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.restaurantApetiloImage._1) + ")"; }
              if (v.restaurantApetiloImage.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["restaurantId", Data$dShow.showIntImpl(v.restaurantId)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "restaurantName",
            Data$dShow.showStringImpl(v.restaurantName)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "restaurantPhones",
            (() => {
              if (v.restaurantPhones.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.restaurantPhones._1) + ")"; }
              if (v.restaurantPhones.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "restaurantSlug",
            (() => {
              if (v.restaurantSlug.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.restaurantSlug._1) + ")"; }
              if (v.restaurantSlug.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "siteName",
            (() => {
              if (v.siteName.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.siteName._1) + ")"; }
              if (v.siteName.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["state", showOrderSummaryState.show(v.state)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "userLoyalty",
            (() => {
              if (v.userLoyalty.tag === "Just") { return "(Just " + Restaumatic$dPromotions$dLoyalty$dTypes$dUserLoyalty.showUserLoyalty.show(v.userLoyalty._1) + ")"; }
              if (v.userLoyalty.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]))))))))))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "GetOrderSummaryResponse"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetOrderSummaryResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "orderInfo"})(Restaumatic$dOrders$dTypes$dOrderInfo.unscrambleDecodeOrderInfo)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "restaurantAddressCity"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantAddressPostCode"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "restaurantAddressStreet"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantApetiloImage"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "restaurantId"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantName"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "restaurantPhones"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantSlug"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "siteName"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "state"})(unscrambleDecodeOrderSummaryState)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "userLoyalty"
    })(Unscramble.decodeMaybe(Restaumatic$dPromotions$dLoyalty$dTypes$dUserLoyalty.unscrambleDecodeUserLoyalty))(Unscramble.decodeRecordNil)))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGetOrderSummaryRequest = {to: x => $GetOrderSummaryRequest(x), from: x => x._1};
const showGetOrderSummaryRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["orderId", Restaumatic$dOrders$dTypes.showOrderUUID.show(v.orderId)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "GetOrderSummaryRequest"});
    return x => $0["genericShow'"](x._1);
  })()
};
const unscrambleDecodeGetOrderSummaryRequest = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "orderId"})(Restaumatic$dOrders$dTypes.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy));
    return x => $GetOrderSummaryRequest($0(x));
  })()
};
const genericGetCheckoutInfoRequest = {to: x => x, from: x => x};
const showGetCheckoutInfoRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["isQrWaiterOrder", v.isQrWaiterOrder ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "locale",
            Restaumatic$dLocales.showLocale.show(v.locale)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["restaurantId", Data$dShow.showIntImpl(v.restaurantId)]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "GetCheckoutInfoRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetCheckoutInfoRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "isQrWaiterOrder"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "locale"
    })(Restaumatic$dLocales.udecodeLocale)(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericFulfillmentTimeChoice = {to: x => x, from: x => x};
const showFulfillmentTimeChoice = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["label", Data$dShow.showStringImpl(v.label)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "value",
            (() => {
              if (v.value.tag === "Just") { return "(Just " + DateUtils.formatISODateTime(v.value._1) + ")"; }
              if (v.value.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "FulfillmentTimeChoice"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeFulfillmentTimeChoice = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "label"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "value"
    })(Unscramble.decodeMaybe(Data$dUTCTime.unscrambleDecodeUTCTime))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCheckoutInfo = {to: x => x, from: x => x};
const showCheckoutInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dOrders$dTypes$dPaymentMethod.showPaymentMethod.show);
      const $1 = Data$dShow.showArrayImpl(showFulfillmentTimeChoice.show);
      const $2 = Data$dShow.showArrayImpl(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.showFulfillmentMethodType.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["companyCity", Data$dShow.showStringImpl(v.companyCity)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "companyName",
              Data$dShow.showStringImpl(v.companyName)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["country", Restaumatic$dCountries.showCountry.show(v.country)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "franchiseName",
              (() => {
                if (v.franchiseName.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.franchiseName._1) + ")"; }
                if (v.franchiseName.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["fulfillmentMethods", $2(v.fulfillmentMethods)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "fulfillmentTimes",
              $1(v.fulfillmentTimes)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["paylanePublicApiKey", Data$dShow.showStringImpl(v.paylanePublicApiKey)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "paymentMethods",
              $0(v.paymentMethods)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["restaurantName", Data$dShow.showStringImpl(v.restaurantName)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "signedIn",
              v.signedIn ? "true" : "false"
            ]))([]))))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "CheckoutInfo"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCheckoutInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "companyCity"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "companyName"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "country"})(Restaumatic$dCountries.unscrambleDecodeCountry)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "franchiseName"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "fulfillmentMethods"})({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.unscrambleDecodeFulfillmentMethodType.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "fulfillmentTimes"})({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeFulfillmentTimeChoice.unsafeDecode)})(Unscramble.decodeRecordCons({
      reflectSymbol: () => "paylanePublicApiKey"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "paymentMethods"})({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dOrders$dTypes$dPaymentMethod.unscrambleDecodePaymentMethod.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantName"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "signedIn"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil)))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodePlaceOrderResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPlaceOrderResponse)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Errors"})((() => {
      const $0 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0(v)), Data$dList$dTypes.Nil)};
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Redirect"})((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "url"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      }))({reflectSymbol: () => "orderUUID"})({encodeWithOptions: v => Restaumatic$dOrders$dTypes.encodeOrderUUID.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ExternalRedirect"})((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "url"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      }))({reflectSymbol: () => "orderUUID"})({encodeWithOptions: v => Restaumatic$dOrders$dTypes.encodeOrderUUID.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "PaymentForm"})((() => {
      const $3 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "orderUUID"})({
        encodeWithOptions: v => Restaumatic$dOrders$dTypes.encodeOrderUUID.encode
      }))({reflectSymbol: () => "form"})({encodeWithOptions: v => Restaumatic$dOrders$dPayments$dTypes.encodeForm.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $3.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ApplePayResponseToken"})((() => {
      const $4 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "url"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "token"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
        reflectSymbol: () => "orderUUID"
      })({encodeWithOptions: v => Restaumatic$dOrders$dTypes.encodeOrderUUID.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $4.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              if (v._1._1._1.tag === "Inl") {
                return $3.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1._1);
              }
              if (v._1._1._1.tag === "Inr") {
                return $4.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1._1);
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodePlaceOrderRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPlaceOrderRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "PlaceOrderRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "paymentChannel"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dPayments$dDotpay$dTypes.encodeChannelId.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "payment"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dPayments$dTypes.encodePaymentRequest.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "origin"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "checkout"})({
      encodeWithOptions: v => Restaumatic$dOrders$dCheckout$dTypes.encodeCheckoutRequest.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeOrderSummaryState = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericOrderSummaryState)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Placed"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "WaitingForPayment"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "WaitingForDispatch"})((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "openAt"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "WaitingForConfirmation"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Completed"})(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", DateUtils.formatISODateTime(v)), Data$dList$dTypes.Nil)}));
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Cancelled"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg(
          "PlainArg",
          (() => {
            if (v.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (v.tag === "Just") { return v._1; }
            $runtime.fail();
          })()
        ),
        Data$dList$dTypes.Nil
      )
    });
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              if (v._1._1._1.tag === "Inl") {
                return $3.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1._1);
              }
              if (v._1._1._1.tag === "Inr") {
                if (v._1._1._1._1.tag === "Inl") {
                  return $4.encodeOpts({
                    sumEncoding: opts.sumEncoding,
                    unwrapSingleConstructors: false,
                    unwrapSingleArguments: opts.unwrapSingleArguments,
                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                    fieldTransform: opts.fieldTransform
                  })(v._1._1._1._1._1);
                }
                if (v._1._1._1._1.tag === "Inr") {
                  return $5.encodeOpts({
                    sumEncoding: opts.sumEncoding,
                    unwrapSingleConstructors: false,
                    unwrapSingleArguments: opts.unwrapSingleArguments,
                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                    fieldTransform: opts.fieldTransform
                  })(v._1._1._1._1._1);
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeGetOrderSummaryResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetOrderSummaryResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "GetOrderSummaryResponse"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "userLoyalty"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dPromotions$dLoyalty$dTypes$dUserLoyalty.encodeUserLoyalty.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "state"})({encodeWithOptions: v => encodeOrderSummaryState.encode}))({reflectSymbol: () => "siteName"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "restaurantSlug"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "restaurantPhones"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "restaurantName"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "restaurantId"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "restaurantApetiloImage"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "restaurantAddressStreet"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "restaurantAddressPostCode"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "restaurantAddressCity"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "orderInfo"})({
      encodeWithOptions: v => Restaumatic$dOrders$dTypes$dOrderInfo.encodeOrderInfo.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetOrderSummaryRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetOrderSummaryRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "GetOrderSummaryRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "orderId"})({
      encodeWithOptions: v => Restaumatic$dOrders$dTypes.encodeOrderUUID.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetCheckoutInfoRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "GetCheckoutInfoRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "restaurantId"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "locale"})({encodeWithOptions: v => Restaumatic$dLocales.encodeLocale.encode}))({
      reflectSymbol: () => "isQrWaiterOrder"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeFulfillmentTimeChoice = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericFulfillmentTimeChoice)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "FulfillmentTimeChoice"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "value"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return DateUtils.formatISODateTime(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "label"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCheckoutInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCheckoutInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CheckoutInfo"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "signedIn"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "restaurantName"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
      reflectSymbol: () => "paymentMethods"
    })((() => {
      const $0 = Data$dFunctor.arrayMap(Restaumatic$dOrders$dTypes$dPaymentMethod.encodePaymentMethod.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "paylanePublicApiKey"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "fulfillmentTimes"})((() => {
      const $0 = Data$dFunctor.arrayMap(encodeFulfillmentTimeChoice.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "fulfillmentMethods"})((() => {
      const $0 = Data$dFunctor.arrayMap(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.encodeFulfillmentMethodType.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "franchiseName"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "country"})({encodeWithOptions: v => Restaumatic$dCountries.encodeCountry.encode}))({reflectSymbol: () => "companyName"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "companyCity"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodePlaceOrderResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPlaceOrderResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Errors"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode);
    return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
  })())(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Redirect"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "url"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "orderUUID"})({
    decodeWithOptions: v => Restaumatic$dOrders$dTypes.decodeOrderUUID.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ExternalRedirect"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "url"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "orderUUID"})({
    decodeWithOptions: v => Restaumatic$dOrders$dTypes.decodeOrderUUID.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PaymentForm"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "orderUUID"
  })({decodeWithOptions: v => Restaumatic$dOrders$dTypes.decodeOrderUUID.decode})())({reflectSymbol: () => "form"})({
    decodeWithOptions: v => Restaumatic$dOrders$dPayments$dTypes.decodeForm.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "ApplePayResponseToken"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "url"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "token"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "orderUUID"})({decodeWithOptions: v => Restaumatic$dOrders$dTypes.decodeOrderUUID.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))))))
};
const decodePlaceOrderRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPlaceOrderRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PlaceOrderRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "paymentChannel"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dPayments$dDotpay$dTypes.decodeChannelId.decode)})())({
    reflectSymbol: () => "payment"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dPayments$dTypes.decodePaymentRequest.decode)})())({reflectSymbol: () => "origin"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "checkout"})({decodeWithOptions: v => Restaumatic$dOrders$dCheckout$dTypes.decodeCheckoutRequest.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeOrderSummaryState = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericOrderSummaryState)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Placed"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "WaitingForPayment"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "WaitingForDispatch"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "openAt"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "WaitingForConfirmation"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Completed"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dTime$dLocal.decodeTZLabel.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUTCTime.decodeUTCTime.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  }))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Cancelled"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({
      decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
    }),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument)))))))
};
const decodeGetOrderSummaryResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetOrderSummaryResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetOrderSummaryResponse"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "userLoyalty"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dPromotions$dLoyalty$dTypes$dUserLoyalty.decodeUserLoyalty.decode)})())({
    reflectSymbol: () => "state"
  })({decodeWithOptions: v => decodeOrderSummaryState.decode})())({reflectSymbol: () => "siteName"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "restaurantSlug"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "restaurantPhones"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "restaurantName"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "restaurantId"})({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "restaurantApetiloImage"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "restaurantAddressStreet"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "restaurantAddressPostCode"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "restaurantAddressCity"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "orderInfo"})({decodeWithOptions: v => Restaumatic$dOrders$dTypes$dOrderInfo.decodeOrderInfo.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetOrderSummaryRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetOrderSummaryRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetOrderSummaryRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "orderId"
  })({decodeWithOptions: v => Restaumatic$dOrders$dTypes.decodeOrderUUID.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetCheckoutInfoRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetCheckoutInfoRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "restaurantId"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "locale"})({decodeWithOptions: v => Restaumatic$dLocales.decodeLocale.decode})())({
    reflectSymbol: () => "isQrWaiterOrder"
  })({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeFulfillmentTimeChoice = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericFulfillmentTimeChoice)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "FulfillmentTimeChoice"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "value"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUTCTime.decodeUTCTime.decode)})())({reflectSymbol: () => "label"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCheckoutInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCheckoutInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CheckoutInfo"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "signedIn"
  })({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "restaurantName"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "paymentMethods"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dOrders$dTypes$dPaymentMethod.decodePaymentMethod);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "paylanePublicApiKey"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "fulfillmentTimes"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeFulfillmentTimeChoice);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "fulfillmentMethods"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.decodeFulfillmentMethodType);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "franchiseName"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "country"
  })({decodeWithOptions: v => Restaumatic$dCountries.decodeCountry.decode})())({reflectSymbol: () => "companyName"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "companyCity"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $GetOrderSummaryRequest,
  $OrderSummaryState,
  $PlaceOrderResponse,
  ApplePayResponseToken,
  Cancelled,
  CheckoutInfo,
  Completed,
  Errors,
  ExternalRedirect,
  FulfillmentTimeChoice,
  GetCheckoutInfoRequest,
  GetOrderSummaryRequest,
  GetOrderSummaryResponse,
  PaymentForm,
  PlaceOrderRequest,
  Placed,
  Redirect,
  WaitingForConfirmation,
  WaitingForDispatch,
  WaitingForPayment,
  decodeCheckoutInfo,
  decodeFulfillmentTimeChoice,
  decodeGetCheckoutInfoRequest,
  decodeGetOrderSummaryRequest,
  decodeGetOrderSummaryResponse,
  decodeOrderSummaryState,
  decodePlaceOrderRequest,
  decodePlaceOrderResponse,
  encodeCheckoutInfo,
  encodeFulfillmentTimeChoice,
  encodeGetCheckoutInfoRequest,
  encodeGetOrderSummaryRequest,
  encodeGetOrderSummaryResponse,
  encodeOrderSummaryState,
  encodePlaceOrderRequest,
  encodePlaceOrderResponse,
  eqCheckoutInfo,
  eqFulfillmentTimeChoice,
  eqGetCheckoutInfoRequest,
  eqGetOrderSummaryRequest,
  eqGetOrderSummaryResponse,
  eqOrderSummaryState,
  eqPlaceOrderRequest,
  eqPlaceOrderResponse,
  genericCheckoutInfo,
  genericFulfillmentTimeChoice,
  genericGetCheckoutInfoRequest,
  genericGetOrderSummaryRequest,
  genericGetOrderSummaryResponse,
  genericOrderSummaryState,
  genericPlaceOrderRequest,
  genericPlaceOrderResponse,
  hasFieldCheckoutInfo,
  hasFieldFulfillmentTimeCh,
  hasFieldGetCheckoutInfoRe,
  hasFieldGetOrderSummaryRe,
  hasFieldPlaceOrderRequest,
  newtypeCheckoutInfo_,
  newtypeFulfillmentTimeCho,
  newtypeGetCheckoutInfoReq,
  newtypeGetOrderSummaryRes,
  newtypePlaceOrderRequest_,
  rPCMethodNameGetCheckoutI,
  rPCMethodNameGetOrderSumm,
  rPCMethodNamePlaceOrderRe,
  showCheckoutInfo,
  showFulfillmentTimeChoice,
  showGetCheckoutInfoRequest,
  showGetOrderSummaryRequest,
  showGetOrderSummaryResponse,
  showOrderSummaryState,
  showPlaceOrderRequest,
  showPlaceOrderResponse,
  unscrambleDecodeCheckoutInfo,
  unscrambleDecodeFulfillmentTimeChoice,
  unscrambleDecodeGetCheckoutInfoRequest,
  unscrambleDecodeGetOrderSummaryRequest,
  unscrambleDecodeGetOrderSummaryResponse,
  unscrambleDecodeOrderSummaryState,
  unscrambleDecodePlaceOrderRequest,
  unscrambleDecodePlaceOrderResponse
};
